import PropTypes from 'prop-types';
import { USER_TYPES } from 'react/signups/card/recipes/constants';

const userTypeShape = PropTypes.oneOf([
  USER_TYPES.FAMILY,
  USER_TYPES.CLIENT,
  USER_TYPES.MYSELF,
  '',
]);

export default userTypeShape;
